import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { BlogImage } from "@/components/custom/BlogImage";
import { Prose } from "@/components/custom/Prose";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import type { TypeBlogImageSkeleton, TypeProseSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
type ProseEntry = Entry<TypeProseSkeleton, undefined, string>;
type BlogImageEntry = Entry<TypeBlogImageSkeleton, undefined, string>;
type BodyBlock = Entry<TypeBlogImageSkeleton | TypeProseSkeleton, undefined, string> | UnresolvedLink<"Entry">;
interface Props {
  bodyContent: BodyBlock[] | undefined;
}
export const BlogArticleBody = t0 => {
  const $ = _c(4);
  const {
    bodyContent
  } = t0;
  if (!bodyContent) {
    return null;
  }
  let t1;
  if ($[0] !== bodyContent) {
    t1 = bodyContent.filter(_temp).map(_temp2);
    $[0] = bodyContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col items-start gap-6 p-6 max-w-3xl mx-auto w-full">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(block) {
  return "fields" in block;
}
function _temp2(block_0) {
  const proseEntry = getEntryOfContentType(block_0, "prose");
  if (proseEntry) {
    return <Prose key={proseEntry.sys.id} content={proseEntry.fields.content} />;
  }
  const imageEntry = getEntryOfContentType(block_0, "blogImage");
  if (imageEntry) {
    const img = ContentfulHelper.parseContentfulContentImage(imageEntry.fields.media);
    if (!img) {
      return null;
    }
    return <BlogImage key={imageEntry.sys.id} image={img} entryId={imageEntry.sys.id} />;
  }
  return null;
}